import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { IconBolt, IconWorld, IconShield, IconCurrencyDollar } from '@tabler/icons-react';

const Whychoose = () => {
  return (
    <>
      <section className="whychoose">
        <Container>
          <Row>
            <Col md={12}>
              <div className="head-title">
                <div className="sup">Features</div>
                <h2>Why Choose <span className='text-gradient'>MyFX.ca?</span></h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconBolt size={24} strock={2} /></div>
                <span>Speed</span>
                <h3>Fast and Secure Transactions</h3>
                <p>Experience swift and protected financial operations across borders.</p>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconWorld size={24} strock={2} /></div>
                <span>Network</span>
                <h3>Global Network of Partners</h3>
                <p>Access a wide network spanning North America, Latin America, Asia, and Africa.</p>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconShield size={24} strock={2} /></div>
                <span>Compliance</span>
                <h3>Licensed and Registered</h3>
                <p>Fully compliant with FINTRAC Canada regulations for your peace of mind.< br /><small>(FINTRAC Reg. No. M20666701)</small></p>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconCurrencyDollar size={24} strock={2} /></div>
                <span>Affordability</span>
                <h3>Competitive <br />Rates</h3>
                <p>Benefit from our favorable exchange rates for major global currencies.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Whychoose